import { SecureService } from './secureService'
import { Config } from '../utilities/config'
import { Helpers } from '../utilities/helpers'

class _Service extends SecureService {

  sendWebEvent = async (params) => {
    try {
    const authUser = await Helpers.getAuthUser()
    const splitData = document.cookie.split(';')
    const afCookieUserId = splitData.find((cookies) => {
      const pattern = /afUserId/
      if (pattern.test(cookies)) return cookies.substr(10)
    })
    const splitAfData = afCookieUserId ? afCookieUserId.split('=') : null
    const afID = splitAfData ? splitAfData[1] : null
    params.user_id = authUser.id
    params.customerUserId = authUser ? authUser.id : afCookieUserId
    params.afUserId = afID
    const response = await fetch(Config.services.tags.create, {
      method: 'POST',
      headers: {
        ...this.defaultHeaders,
        Authorization: this.generateAuthHeader(),
      },
      body: JSON.stringify(params),
    })
    
      if (!response.ok) {
        console.error('Network response was not ok')
      }

    return response.json()
    } catch (error) {
      console.error('error', error)
    }
  }
}

const tag = new _Service()
export { tag }